import astro from "./logos/astro.svg";
import docker from "./logos/docker.svg";
import git from "./logos/git.svg";
import gitlab from "./logos/gitlab.svg";
import graphql from "./logos/graphql.svg";
import html5 from "./logos/html5.svg";
import jest from "./logos/jest.svg";
import js from "./logos/js.svg";
import kiro from "./logos/kiro.svg";
import mongodb from "./logos/mongodb.svg";
import mysql from "./logos/mysql.svg";
import nodejs from "./logos/nodejs.svg";
import react from "./logos/react.svg";
import sass from "./logos/sass.svg";
import stencil from "./logos/stencil.svg";
import ts from "./logos/typescript.svg";
import vite from "./logos/vite.svg";
import webpack from "./logos/webpack.svg";
import zustand from "./logos/zustand.svg";

export const icons = {
  astro,
  docker,
  git,
  gitlab,
  graphql,
  html5,
  jest,
  js,
  kiro,
  mongodb,
  mysql,
  nodejs,
  react,
  sass,
  stencil,
  ts,
  vite,
  webpack,
  zustand,
};
